// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message__XvOeUMsa_y{margin-bottom:var(--dixa-size-spacer-400)}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/integrations/elevio/src/components/KnowledgeErrorPlaceholder/KnowledgeErrorPlaceholder.module.scss"],"names":[],"mappings":"AAEA,qBACE,yCAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.message {\n  margin-bottom: var(--dixa-size-spacer-400);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `message__XvOeUMsa_y`
};
export default ___CSS_LOADER_EXPORT___;
